
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/prototyping",
      function () {
        return require("private-next-pages/services/prototyping.tsx");
      }
    ]);
  